module.exports = __webpack_public_path__ + "img/eg-15-01.1217df23.jpg";